import { useEffect, useState } from "react";
import api from "./store/api";
import CustomInput from "../../../components/CustomInput";
import CustomButton from "../../../components/CustomButton";
import AddIcon from "../../../components/Icons/add.svg";
import { Pagination, Popconfirm, Table } from "antd";
import UpdateIcon from "../../../components/Icons/update.svg";
import DeleteIcon from "../../../components/Icons/delete.svg";
import RestoreIcon from "../../../components/Icons/restore.svg";
import AuditIcon from "../../../components/Icons/audit.svg";
import { deleteAction, 
         restoreAction,
         getPagedAllAction,
         clearAction,
         getPagedAction,
         } from "./store/actions"
import Notifications from "../../../helpers/Notifications";
import { useDebounce } from "use-debounce";
import { useDispatch, useSelector } from "react-redux";
import LocalLoading from "../../../components/Loading/Local";
import { useTranslation } from "react-i18next";
import ReObjectFunctionTypeChangeForm from "./change";
import ModalAudit from "../ModalAudit";
import dayjs from "dayjs";

const ReObjectFunctionType = ({isModify = false}) => {
    const [visible, setVisible] = useState(false);
    const [record, setRecord] = useState(null);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState(null);
    const [visibleAudit, setVisibleAudit] = useState(false)
    const [idRecordAudit, setIdRecordAudit] = useState(null)
    const { paged,  changed, isLoading } = useSelector(state => state.reObjectFunctionTypeReducer)
    const [searchValue] = useDebounce(search, 500);
    const { t } = useTranslation(["common", "valid", "action"]);
    const dispatch = useDispatch();
    const pageSize = 10;

    useEffect(() => {
        onPaginationChange(1);
    }, [searchValue]);

      useEffect(() => {
        if (changed) {
            Notifications.successNotice(changed, "", 10);
            setVisible(false);
            onPaginationChange(page);
            dispatch(clearAction())
        }
    }, [changed])

    function onPaginationChange(value) {
        setPage(value);
        const params = {
            name: searchValue?.trim(),
            pageSize: pageSize,
            page: value,
        };
        isModify ? dispatch(getPagedAllAction(params)) : dispatch(getPagedAction(params));
    }
    
    const comColumns = [
        {
            title: `1 ${t("common:level").toLowerCase()}`,
            dataIndex: "code1",
            key: "code1",
            width: "8%",
            align: "right",
        },
        {
            title: `2 ${t("common:level").toLowerCase()}`,
            dataIndex: "code2",
            key: "code2",
            width: "8%",
            align: "right",
        },
        {
            title: `3 ${t("common:level").toLowerCase()}`,
            dataIndex: "code3",
            key: "code3",
            width: "8%",
            align: "right",
        },
        {
            title: `4 ${t("common:level").toLowerCase()}`,
            dataIndex: "code4",
            key: "code4",
            width: "8%",
            align: "right",
        },
        {
            title: t("common:name"),
            dataIndex: "name",
            key: "name",
        },
    ]

    const manageColumns = [
        ...comColumns,
        {
            title       : t("common:dateCreate"),
            dataIndex   : "createDate",
            key         : "createDate",
            width       : "10%",
            render      : (date) => dayjs(date).format("DD.MM.YYYY"),
        },
        {
            dataIndex: "id",
            key: "id",
            width: 100,
            render: (id, record) => (
                <div className="changeIcon">
                    <img alt=""
                        src={UpdateIcon}
                        title={t("action:edit")}
                        onClick={() => {
                            setVisible(true);
                            setRecord(record);
                        }}
                    />
                    <Popconfirm
                        cancelText={t("no")}
                        okText={t("yes")}
                        placement="left"
                        title={
                            !record.isDeleted
                                ? t("valid:sureToDelete")
                                : t("valid:sureToRestore")
                        }
                        onCancel={(e) => {
                            e.stopPropagation();
                            return null;
                        }}
                        onConfirm={(e) => {
                            e.stopPropagation();
                            !record.isDeleted
                                ? dispatch(deleteAction({ id }))
                                : dispatch(restoreAction({ id }))
                        }}
                    >
                        <img alt=""
                            src={!record.isDeleted ? DeleteIcon : RestoreIcon}
                            title={
                                !record.isDeleted
                                    ? t("action:delete")
                                    : t("action:restore")
                            }
                        />
                    </Popconfirm>
                    <img alt=""
                        className="audit-icon-svg"
                        src={AuditIcon}
                        title={t('common:historyOfChange')}
                        onClick={() => {
                            setVisibleAudit(true)
                            setIdRecordAudit(id)
                        }}
                    />
                </div>
            )
        }
    ];
    return (
        <>
            <div className="header-admin-nsi">
                <CustomInput
                    maxLength={64}
                    placeholder={t("action:enterNameCode")}
                    onChange={(e) => setSearch(e.target.value)}
                />
                {isModify && (
                    <CustomButton
                        className="add-nsi"
                        type="green"
                        onClick={() => {
                            setRecord(null);
                            setVisible(true);
                        }}
                    >
                        <div>
                            <img alt="" src={AddIcon} />
                            <span>{t("action:add")}</span>
                        </div>
                    </CustomButton>
                )}
            </div>
            <Table
                columns={isModify ? manageColumns : comColumns}
                dataSource={paged?.items}
                rowKey={({id}) => id}
                loading={{ indicator: <LocalLoading />, spinning: isLoading }}
                pagination={false}
                scroll={{ x: 1100 }}
            />
            {paged?.count > pageSize && (
                <Pagination
                    showQuickJumper
                    current={page}
                    pageSize={pageSize}
                    showSizeChanger={false}
                    size="small"
                    total={paged?.count}
                    onChange={onPaginationChange}
                />
            )}
            {isModify && (
                <ReObjectFunctionTypeChangeForm
                    record={record}
                    setRecord={setRecord}
                    setVisible={setVisible}
                    visible={visible}
                />
            )}
            <ModalAudit
                columns={ comColumns }
                setIdRecordAudit={ setIdRecordAudit }
                idRecordAudit={ idRecordAudit }
                setVisible={ setVisibleAudit }
                visible={ visibleAudit }
                pageSize={ pageSize }
                func={ api.getPagedAudit }
            />
        </>
    );
};
export default ReObjectFunctionType;
